import type { FieldRenderProps } from 'react-final-form'
import type { PublicProps as Props } from './typings'

import { Field as FinalFormField } from 'react-final-form'

import { isDeepEqual } from '@/server-data'

import { DriverBehaviorField } from './DriverBehaviorField'

export function DriverBehaviorFieldWrapper(props: Props) {
  const { name, ...rest } = props

  return (
    <FinalFormField
      {...rest}
      name={name}
      isEqual={isDeepEqual}
      render={(formProps: FieldRenderProps<any>) => {
        return <DriverBehaviorField {...props} formProps={formProps} />
      }}
    />
  )
}
